import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type VersionResponse = { version: string };
async function fetchVersion(): Promise<string | null> {
    const res = await fetch("/version.json?t=" + Date.now());
    if (!res.ok) return null;
    const data = (await res.json()) as VersionResponse;
    return data.version ?? null;
}

export function useGetVersion(options?: Omit<UseQueryOptions<string | null>, "queryFn" | "queryKey">) {
    return useQuery({
        queryKey: ["app-version"],
        queryFn: async () => {
            return await fetchVersion();
        },
        ...options,
    });
}

export function usePollVersion() {
    return useGetVersion({ refetchInterval: 10_000 });
}
